import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../index.css"

import brand1 from "../assets/brands/brand1.png";
import brand2 from "../assets/brands/brand2.png";
import brand3 from "../assets/brands/brand3.png";
import brand4 from "../assets/brands/brand4.png";
import brand5 from "../assets/brands/brand6.png";
import brand6 from "../assets/brands/brand5.png";

const ImageCarousel = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4, // Number of images visible at once
    slidesToScroll: 1, // Scroll one image at a time
    autoplay: true,
    autoplaySpeed: 2000,
    prevArrow: null, // Hide the previous arrow button
    nextArrow: null, // Hide the next arrow button
    responsive: [
      {
        breakpoint: 768, // Adjust for smaller screens
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const images = [
    { src: brand1, alt: "Make Easy Documents maharashtra e seva" },
    { src: brand2, alt: "Make Easy Documents Make easy Documents" },
    { src: brand3, alt: "Make Easy Documents Ambiance" },
    { src: brand4, alt: "Make Easy Documents Digital legal india" },
    { src: brand5, alt: "Make Easy Documents Viransh global legal" },
    { src: brand6, alt: "Make Easy Documents 7/12 maza" },
  ];

  return (
    <div className="w-full px-4" >
      <Slider {...settings}>
        {images.map((image, index) => (
          <div key={index} className="flex justify-center">
            <img
              className="w-48 h-48 md:w-64 md:h-64 transition-transform duration-300 hover:scale-105"
              src={image.src}
              alt={image.alt}
              style={{
                margin: "0px", // Decrease the gap between images
                objectFit: "cover", // Keep the aspect ratio
                boxShadow: "none", // Remove any shadow
                border: "none", // Remove any border
                outline: "none", // Remove focus outline
              }}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};
export default ImageCarousel;